import entraId from "@/store/app/entraId/recovery/entraId";
import object from "@/store/app/entraId/recovery/object";

export default {
  namespaced: true,

  actions: {},

  modules: {
    entraId,
    object
  }
}
